/**
`com-calendar-date`
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import './style/com-calendar-date-style.js';

import { IronButtonState } from '@polymer/iron-behaviors/iron-button-state.js';
import { IronControlState } from '@polymer/iron-behaviors/iron-control-state.js';

import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import {IronA11yKeysBehavior} from '@polymer/iron-a11y-keys-behavior/iron-a11y-keys-behavior.js';

class COMCalendarDate extends mixinBehaviors([
  IronA11yKeysBehavior,
  IronButtonState,
  IronControlState
], PolymerElement) {
  static get template() {
    return html`
    <!-- Scoped styles for this element -->
    <style include="com-theme"></style>
    <style include="com-calendar-date-style"></style>

    <div class="dateContainerOuter">
      <div class="dateContainerInner">
        <div id="date-container" on-tap="_tapHandler" tabindex="0" role="button" aria-selected="[[selected]]" aria-label="[[date]]">
          <div class="number">
            [[_getDayOfMonthNumber(date)]]
            <svg aria-hidden="true" class="slash" disabled=""><line x1="0" y1="20%" x2="100%" y2="80%"></line></svg>
          </div>
          <div id="slotWrapper"></div>
          <div id="loadingWrapper" hidden$="[[!_showLoading(loading, disabled)]]"><span class="loading icon-font"></span></div>
        </div>
        <div class="padding"></div>
      </div>

      <div class="dateTypeIndicatorContainer" aria-hidden="true">
        <slot name="dateTypeIndicator"></slot>
      </div>
    </div>
`;
  }

  static get is() { return 'com-calendar-date'; }
  static get properties() {
    return {
      /**
       * @desc Adpative string
       * @type {String}
       */
       adaptive: {
        type: String,
        reflectToAttribute: true
      },
      /**
       * @desc date
       * @type {String}
       */
      date: {
        type: String,
        reflectToAttribute: true
      },
      /**
       * @desc slot
       * @type {String}
       */
      slot: {
        type: String,
        observer: '_updateDateFromSlot',
        reflectToAttribute: true,
        notify: true
      },
      /**
       * @desc selected
       * @type {Boolean}
       */
      selected: {
        type: Boolean,
        notify: true,
        reflectToAttribute: true
      },
      /**
       * @desc the date selected for the calendar
       * @type {String}
       */
      calendarSelectedDate: {
        type: String
      },
      /**
       * @desc role for accessibility
       * @type {String}
       */
      role: {
        type: String,
        computed: '_getRole(disabled, enableNavToDisabledDates)',
        reflectToAttribute: true
      },
      /**
       * @desc tabindex
       * @type {Number}
       */
      tabindex: {
        type: Number,
        value: 0,
        reflectToAttribute: true
      },
      /**
       * @desc disabled attribute
       * @type {Boolean}
       */
      disabled: {
        type: Boolean,
        reflectToAttribute: true,
        value: false
      },
      /**
       * @desc is past date
       * @type {Boolean}
       */
      past: {
        type: Boolean,
        reflectToAttribute: true,
        value: false
      },
      /**
       * @desc is unavailable date
       * @type {Boolean}
       */
      unavailable: {
        type: Boolean,
        reflectToAttribute: true,
        value: false
      },
      /**
       * @desc presentation from calendar
       * @type {String}
       */
      presentation: {
        type: String,
        reflectToAttribute: true
      },
      /**
       * @desc aria-label attribute
       * @type {String}
       */
      ariaLabel: {
        type: String,
        reflectToAttribute: true
      },
      /**
       * @desc class
       * @type {String}
       */
      class: {
        type: String,
        reflectToAttribute: true
      },
      /**
       * @desc activate animation
       * @type {Boolean}
       */
      selectedDateAnimation: {
        type: Boolean,
        reflectToAttribute: true
      },

      /**
       * @desc loading
       * @type {Boolean}
       */
      loading: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * @desc allow focus on disabled dates to allow guests to read info only calendars
       * @type {Boolean}
       */
      allowDisabledFocus: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * @desc allows selection of unavailable dates
       * @type {Boolean}
       */
      allowUnavailableSelection: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * @desc Flag to indicate if calendar should enable the disable dates with accessibility label
       * @type {Boolean}
       */
       enableNavToDisabledDates: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Flag to indicate if calendar should enable the past dates with accessibility label
       * @type {Boolean}
       */
       enableNavToPastDates: {
        type: Boolean,
        value: false
      },
      /**
       * @desc disable not available dates by default
       * @type {Boolean}
       */
      forceDisabled: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * @desc Flag to indicate if calendar should be interactive
       * @type {Boolean}
       */
      disableUserInteraction: {
        type: Boolean,
        value: false
      },
      slashOnBlockedOnly: {
        type: Boolean,
        value: false
      }
    };
  }

  ready() {
    super.ready();

    // If IE, add simple observer to force updateStyles() when custom css is updated
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      this._createPropertyObserver('class', '_updateStyles');
    }
  }

  /**
   * @desc Force updateStyles for IE
   * @param {String} newVal
   * @param {String} oldVal
   */
  _updateStyles(newVal, oldVal) {
    if (oldVal !== undefined && oldVal !== newVal) {
      timeOut.run(() => { this.updateStyles(); }, 0);
    }
  }

  /**
   * @desc Update date from slot
   * @param {String} slot
   */
  _updateDateFromSlot(slot) {
   if (!slot) return;
   this.date = slot;
  }

  /**
   * Get day of the month from date
   * @param {String} date
   * @return {String} number
   */
  _getDayOfMonthNumber(date) {
    if (!date) {
      return '';
    }
    date = this._formatDateFromString(date);
    return date.getDate();
  }

  /**
   * @desc get date object
   * @param {String} date
   * @return {Date} date
   */
  _formatDateFromString(date) {
    let d = date.split('-');
    date = new Date(d[0], d[1] - 1, d[2]);
    return date;
  }

  /**
   * @desc notify calendar of selection, block the enter key when the day is not allowed to be selected
   * @param {Event} e
   */
  _tapHandler(e) {
    if (((this.allowDisabledFocus && !this.allowUnavailableSelection) || this.disableUserInteraction) || e.target.class === 'none' || e.target.class === 'unavailable') return;
    if (e.target.class === 'none' || e.target.class === 'unavailable' || e.target.class === 'none selectable' || e.target.class === 'unavailable selectable') return;
    if (e.target.class === 'noInfo' || e.target.class === 'noInfo selectable') return;
    if (this.classList.contains('dimmed')) return;
    this.dispatchEvent(new CustomEvent('com-calendar-date.selected', {
      composed: true,
      bubbles: true,
      detail: {date: this.date}
    }));
    e.stopPropagation();
  }

  /**
   * @desc get role based on disabled state
   * @param {Boolean} disabled
   * @param {Boolean} enableNavToDisabledDates
   * @return {String}
   */
  _getRole(disabled, enableNavToDisabledDates) {
    return (disabled && !enableNavToDisabledDates) ? 'presentation' : 'button';
  }

  /**
   * @desc show loading animation
   * @param {Boolean} loading
   * @param {Boolean} disabled
   * @return {Boolean}
   */
  _showLoading(loading, disabled) {
    return loading && !disabled;
  }
}
window.customElements.define(COMCalendarDate.is, COMCalendarDate);
